module.exports = __webpack_public_path__ + "media/images/landkit/devices/macbook-e49236cc99633f0a588998a8bf71af7c.png";